export default 'M5 1h5.75v22H5c-2.2 0-4-1.8-4-4V5c0-2.2 1.8-4 4-4m18 4v5.75h-9.75V1H19c2.2 0 4 1.8 4 4m-9.75 8.25H23V19c0 2.2-1.8 4-4 4h-5.75z';